/* eslint no-eval: "off" */
import { Link } from '@lmig/lmds-react-link';
import { FunctionComponent } from 'react';
import { StringHelper } from 'Utilities/StringHelper';
import '../../../Styles/KeyContacts.scss';

const KeyContactLink: FunctionComponent<ISitecoreLink> = (props: ISitecoreLink) => {
  return (
    <>
      <div>
        <Link
          className="key-contact"
          variant="standalone"
          caretPosition="none"
          onClick={() => (props.OnClick ? props.OnClick(props.TargetId) : '')}
        >
          <span className="key-contact-name">{props.Text}</span>
          {StringHelper.isGuid(props.TargetId)
            ? ''
            : props.SubText && <span>{`: ${props.SubText}`}</span>}
        </Link>
      </div>
    </>
  );
};

export default KeyContactLink;
